import React, { Component } from 'react';
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import './Booking.css';

export default class Booking extends Component {
    render() {
        return (
            <div className="booking">
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">

                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <h3 className="heading">
                                Book Your ThreatSpy Demo
                            </h3>
                            <div className="booking-form">
                                <Form>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="formGridName">
                                            <Form.Label className="text-muted">
                                                Name<span className="reqd">(*)</span>
                                            </Form.Label>
                                            <Form.Control className="field-select" type="name" placeholder="" />
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="formGridPhone">
                                            <Form.Label className="text-muted">
                                                Contact No.<span className="reqd">(*)</span>
                                            </Form.Label>
                                            <Form.Control className="field-select" type="phone" placeholder="" />
                                        </Form.Group>
                                    </Form.Row>

                                    <Form.Row>
                                        <Form.Group as={Col} controlId="formGridCompany">
                                            <Form.Label className="text-muted">
                                                Email<span className="reqd">(*)</span>
                                            </Form.Label>
                                            <Form.Control className="field-select" type="company " placeholder="" />
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="formGridJobTitle">
                                            <Form.Label className="text-muted">
                                                Country<span className="reqd">(*)</span>
                                            </Form.Label>
                                            <Form.Control
                                                className="field-select"
                                                type="jobtitle"
                                                placeholder=""
                                            />
                                        </Form.Group>
                                    </Form.Row>
                                    <button className="thbtn">
                                        <span className="btncon">Submit</span>
                                    </button>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}